import * as React from 'react';

import CourseRecommendationsModuleNotConfigurable from 'bundles/unified-description-page-common/components/recommendations/CourseRecommendationsModuleNotConfigurable';
import type { EnterpriseCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseCoursePageQuery';
import { COURSE_NAV_ITEMS } from 'bundles/unified-description-page-common/utils/getPageNavigationLinks';

type Props = {
  pageData: EnterpriseCoursePageFieldsFragment;
};

const EnterpriseCourseRecommendationsModuleRenderer = ({ pageData }: Props) => {
  return (
    <CourseRecommendationsModuleNotConfigurable
      anchorId={COURSE_NAV_ITEMS.RECOMMENDATIONS}
      domainName={pageData.domains?.[0]?.domainName}
      recommendationsCollection={pageData?.recommendations}
      relatedCoursesCollection={pageData?.relatedCourses}
    />
  );
};

export default EnterpriseCourseRecommendationsModuleRenderer;
